module.exports = __webpack_public_path__ + "static/img/14000141.bf15e30a.png";